<template>
  <div>
    <Head :title="__(title)" />
    <trashed-message v-if="classData.deleted_at" class="mb-6" @restore="restore">
      {{ __('This class has been deleted.') }}
    </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input 
            v-model="form.name" 
            :error="form.errors.name" 
            class="pb-8 pr-6 w-full lg:w-1/2"
            :label="__('Name')" 
            required
          />
          <select-input 
            v-model="form.status" 
            :error="form.errors.status" 
            class="pb-8 pr-6 w-full lg:w-1/2"
            :label="__('Status')">
            <option :value="true">{{ __('Active') }}</option>
            <option :value="false">{{ __('Inactive') }}</option>
          </select-input>
          <select-input 
            v-model="form.admin_id" 
            :error="form.errors.admin_id" 
            class="pb-8 pr-6 w-full lg:w-1/2"
            :label="__('Group Admin')"
            required>
            <option :value="null">{{ __('Select Admin') }}</option>
            <option v-for="admin in availableAdmins" :key="admin.id" :value="admin.id">
              {{ admin.name }} ({{ admin.role }})
            </option>
          </select-input>
          <textarea-input 
            v-model="form.description" 
            :error="form.errors.description" 
            class="pb-8 pr-6 w-full"
            :label="__('Description')" 
          />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button 
            v-if="!classData.deleted_at" 
            class="text-red-600 hover:underline" 
            tabindex="-1" 
            type="button" 
            @click="destroy">
            {{ __('Delete Class') }}
          </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            {{ __('Update Class') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    title: String,
    classItem: Object,
    availableAdmins: Array,
  },
  remember: 'form',
  data() {
    return {
      classData: this.classItem,
      form: this.$inertia.form({
        name: this.classItem.name,
        description: this.classItem.description,
        status: this.classItem.status,
        admin_id: this.classItem.admin_id,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('classes.update', this.classData.id))
    },
    destroy() {
      if (confirm(this.__('Are you sure you want to delete this class?'))) {
        this.$inertia.delete(this.route('classes.destroy', this.classData.id))
      }
    },
    restore() {
      if (confirm(this.__('Are you sure you want to restore this class?'))) {
        this.$inertia.put(this.route('classes.restore', this.classData.id))
      }
    },
  },
}
</script>
